/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";
import { dialogClasses } from "@mui/material/Dialog";

export const muiDialogStyle = (theme: Theme): Components<Theme>["MuiDialog"] => ({
  styleOverrides: {
    paper: {
      margin: "1rem",
      width: "calc(100% - 2rem)",
      [theme.breakpoints.up("sm")]: {
        margin: "2rem",
        width: "calc(100% - 4rem)",
      },
    },
    root: {
      [`& .${dialogClasses.scrollPaper} > .${dialogClasses.paper}`]: {
        maxHeight: "calc(100% - 48px)",
      },
    },
  },
});
